import axios from 'axios'

import { authApi } from '@/services/auth'

const INVALID_SESSION_TOKEN_TEXT = 'invalid id or session token'

const isInvalidSessionTokenError = (error: unknown): boolean => {
  if (!axios.isAxiosError(error) || error.response?.status !== 401) {
    return false
  }

  const responseData = error.response?.data
  const message = typeof responseData === 'string'
    ? responseData
    : typeof responseData === 'object' && responseData !== null
      ? JSON.stringify(responseData)
      : ''

  return message.toLowerCase().includes(INVALID_SESSION_TOKEN_TEXT)
}

export const withSessionRecovery = async <T>(request: () => Promise<T>): Promise<T> => {
  try {
    return await request()
  } catch (error) {
    if (!isInvalidSessionTokenError(error)) {
      throw error
    }

    await authApi.refreshAuthState().catch(() => undefined)
    return request()
  }
}
